export var SPECS;
(function (SPECS) {
    SPECS["USE_LIGHTBOXES"] = "specs.stores.UseLightboxes";
    SPECS["ShouldUseOnlyBaseUrlAsOrigin"] = "specs.stores.ShouldUseOnlyBaseUrlAsOrigin";
    SPECS["ShouldUseOnlyPlatformExperiments"] = "specs.stores.ShouldUseOnlyPlatformExperiments";
    SPECS["IncreaseGqlGetLimit"] = "specs.stores.increaseGqlGetLimit";
    SPECS["NavigateToRelativeUrlWithCustomizedUrl"] = "specs.stores.navigateToRelativeUrlWithCustomizedUrl";
    SPECS["ShouldInstallSideCart"] = "specs.stores.ShouldInstallSideCart";
    SPECS["InitializePurchaseFlowPropertiesService"] = "specs.stores.InitializePurchaseFlowPropertiesService";
    SPECS["ShouldForceNavigateToProductPage"] = "specs.stores.shouldForceNavigateToProductPage";
    SPECS["AddCheckoutSettingsToGetConfigGQLQuery"] = "specs.stores.AddCheckoutSettingsToGetConfigGQLQuery";
    SPECS["UsePrefixForRouterNavigationToProductPage"] = "specs.stores.UsePrefixForRouterNavigationToProductPage";
    SPECS["FixProductPageUrlsForRouterPage"] = "specs.stores.FixProductPageUrlsForRouterPage";
    SPECS["UseMiniCartForQA"] = "specs.stores.UseMiniCartForQA";
    SPECS["ShouldPreloadEcomPagesAndLightboxes"] = "specs.stores.ShouldPreloadEcomPagesAndLightboxes";
    SPECS["NavigateToCartWhenCallShowMiniCart"] = "specs.stores.NavigateToCartWhenCallShowMiniCart";
    SPECS["AddToCartInLightboxOpneProductPage"] = "specs.stores.AddToCartInLightboxOpneProductPage";
    SPECS["FixGetApiBaseUrl"] = "specs.ecom.FixGetApiBaseUrl";
    SPECS["FixShippingOptionSelectionBug"] = "specs.ecom.FixShippingOptionSelectionBug";
    SPECS["UseAdditionalEcommerceSettings"] = "specs.ecom.UseAdditionalEcommerceSettings";
    SPECS["AddProjectionsTYPQuery"] = "specs.ecom.AddProjectionsTYPQuery";
    SPECS["ErrorHandlerOnCheckout"] = "specs.ecom.ErrorHandlerOnCheckout";
})(SPECS || (SPECS = {}));
export var BI_STOREFRONT_VIEW_MODE;
(function (BI_STOREFRONT_VIEW_MODE) {
    BI_STOREFRONT_VIEW_MODE["SITE"] = "site";
    BI_STOREFRONT_VIEW_MODE["PREVIEW"] = "preview";
    BI_STOREFRONT_VIEW_MODE["EDITOR"] = "editor";
})(BI_STOREFRONT_VIEW_MODE || (BI_STOREFRONT_VIEW_MODE = {}));
export var BI_PRODUCT_OPTION_TYPE;
(function (BI_PRODUCT_OPTION_TYPE) {
    BI_PRODUCT_OPTION_TYPE["COLOR"] = "color";
    BI_PRODUCT_OPTION_TYPE["LIST"] = "list";
})(BI_PRODUCT_OPTION_TYPE || (BI_PRODUCT_OPTION_TYPE = {}));
export var BI_PRODUCT_OPTION_ACTION;
(function (BI_PRODUCT_OPTION_ACTION) {
    BI_PRODUCT_OPTION_ACTION["CHECKED"] = "checked";
    BI_PRODUCT_OPTION_ACTION["UNCHECKED"] = "unchecked";
})(BI_PRODUCT_OPTION_ACTION || (BI_PRODUCT_OPTION_ACTION = {}));
export var ONE_HUNDRED_THOUSAND = 100000;
export var DEFAULT_CART_OPTIONS = { withShipping: false, withTax: false };
export var VIEW_MORE_OPTIONS_URL_FRAGMENT = 'view-more-options';
export var SecondaryEvents = {
    GetGQLRequest: 'CurrentCart.GetGQLRequest',
    GetRequest: 'CurrentCart.GetRequest',
    RefreshRequest: 'CurrentCart.RefreshRequest',
    UpdateQuantityRequest: 'CurrentCart.UpdateQuantityRequest',
    RemoveItemRequest: 'CurrentCart.RemoveItemRequest',
    UpdateBuyerNoteRequest: 'CurrentCart.UpdateBuyerNoteRequest',
    ApplyCouponRequest: 'CurrentCart.ApplyCouponRequest',
    RemoveCouponRequest: 'CurrentCart.RemoveCouponRequest',
    SetAddressRequest: 'CurrentCart.SetAddressRequest',
    SelectShippingOptionRequest: 'CurrentCart.SelectShippingOptionRequest',
    AddToCurrentCart: 'CurrentCart.AddToCurrentCart',
    ActionResponse: 'CurrentCart.ActionResponse',
    EstimateCurrentCartTotals: 'CurrentCart.EstimateCurrentCartTotals',
    Updated: 'CurrentCart.Updated',
    CreateCheckoutRequest: 'CurrentCart.CreateCheckoutRequest',
    HEALTH_CHECK: 'CurrentCart.HEALTH_CHECK',
    ACK: 'CurrentCart.ACK',
};
export var MiniCartEvents = {
    LoadedWithoutData: 'Minicart.LoadedWithoutData',
    OnInitialData: 'Minicart.OnInitialData',
};
//# sourceMappingURL=constants.js.map